import React, { FunctionComponent } from 'react';
import { StandardTextFieldProps, TextField, TextFieldProps } from '@material-ui/core';
import InputMask from 'react-input-mask';

interface ITexfieldMaskProps extends Omit<StandardTextFieldProps, 'variant'> {
    mask: string;
    disabled?: boolean;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    value?: string;
    label?: string;
    id?: string;
    error?: boolean;
    helperText?: string;
    required?: boolean;
    key?: string;
    variant?: TextFieldProps['variant'];
    size?: 'small' | 'medium';
    fullWidth?: boolean;
}

const TextfieldMask: FunctionComponent<ITexfieldMaskProps> = (props: ITexfieldMaskProps) => {
    const {
        mask,
        disabled,
        onChange,
        value,
        label,
        id,
        error,
        helperText,
        required,
        variant = 'standard',
        size,
        fullWidth,
        FormHelperTextProps,
    } = props;

    const textFieldProps = {
        disabled: !!disabled,
        label: label ?? '',
        id: id ?? '',
        required: !!required,
        error: !!error,
        helperText: helperText ?? false,
        variant,
        size,
        fullWidth,
        FormHelperTextProps,
    } as TextFieldProps;

    if (disabled) {
        return (
            <TextField
                {...textFieldProps}
                onChange={onChange}
                value={value ?? ''}
            />
        );
    }

    return (
        <InputMask
            mask={mask}
            maskChar=" "
            disabled={false}
            onChange={onChange}
            value={value ?? ''}
        >
            {(inputProps) => (
                <TextField
                    {...inputProps}
                    {...textFieldProps}
                    disabled={false}
                    onChange={onChange}
                    value={value ?? ''}
                    inputProps={{
                        autoComplete: 'none',
                    }}
                />
            )}
        </InputMask>
    );
};

export default TextfieldMask;
